module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-mask row gutter-xs"
  }, _vm._l((_vm.elements), function(element) {
    return _c('lead-mask-element', {
      key: element.name,
      class: _vm.getItemGrid(element),
      attrs: {
        "type": element.element_type,
        "element": element,
        "errors": _vm.errors,
        "name": element.name,
        "language": _vm.language,
        "item": _vm.item
      },
      on: {
        "populate-fields": _vm.populateFields,
        "change": _vm.change
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-312da585","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/LeadMask.vue
// module id = 1858
// module chunks = 0